import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Contract } from '../interfaces/contract-interfaces';
import { API_ROUTES } from './api-routes';
import { map, Observable } from 'rxjs';
import { ElectricityInvoice, GasInvoice } from '../interfaces/invoice-interfaces';
import { ArchiveFileCounts } from '../interfaces/archive-interfaces.ts';
import { DEFAULT_JSON_HEADERS } from './headers.config';

@Injectable({
  providedIn: 'root'
})
export class ArchiveService {
  constructor(private http: HttpClient) { }

  getElectricityContracts(next_page: number = 1, per_page: number = 20): Observable<any> {
    const params = new HttpParams()
      .set('next_page', next_page)
      .set('per_page', per_page);

    return this.http.get<any>(
      API_ROUTES.ARCHIVE.ELECTRICITY_CONTRACTS,
      { params: params, observe: 'response' }
    ).pipe(
      map(response => {
        const totalCount = response.headers?.get('x-total-count') ? Number(response.headers.get('x-total-count')) : 0;
        return { data: response.body.data || [], totalCount: totalCount };
      }));
  }

  getElectricityInvoices(next_page: number = 1, per_page: number = 20): Observable<any> {
    const params = new HttpParams()
      .set('next_page', next_page)
      .set('per_page', per_page);

    return this.http.get<any>(
      API_ROUTES.ARCHIVE.ELECTRICITY_INVOICES,
      { params: params, observe: 'response' }
    ).pipe(
      map(response => {
        const totalCount = response.headers?.get('x-total-count') ? Number(response.headers.get('x-total-count')) : 0;
        return { data: response.body.data || [], totalCount: totalCount };
      }));
  }

  getGasContracts(next_page: number = 1, per_page: number = 20): Observable<any> {
    const params = new HttpParams()
      .set('next_page', next_page)
      .set('per_page', per_page);

    return this.http.get<any>(
      API_ROUTES.ARCHIVE.GAS_CONTRACTS,
      { params: params, observe: 'response' }
    ).pipe(
      map(response => {
        const totalCount = response.headers?.get('x-total-count') ? Number(response.headers.get('x-total-count')) : 0;
        return { data: response.body.data || [], totalCount: totalCount };
      }));
  }

  getGasInvoices(next_page: number = 1, per_page: number = 20): Observable<any> {
    const params = new HttpParams()
      .set('next_page', next_page)
      .set('per_page', per_page);

    return this.http.get<any>(
      API_ROUTES.ARCHIVE.GAS_INVOICES,
      { params: params, observe: 'response' }
    ).pipe(
      map(response => {
        const totalCount = response.headers?.get('x-total-count') ? Number(response.headers.get('x-total-count')) : 0;
        return { data: response.body.data || [], totalCount: totalCount };
      }));
  }

  getFileCounts(): Observable<any> {
    return this.http.get<ArchiveFileCounts>(
      API_ROUTES.ARCHIVE.FILE_COUNTS,
    );
  }

  getUncategorizedFiles(next_page: number = 1, per_page: number = 20): Observable<any> {
    const params = new HttpParams()
      .set('next_page', next_page)
      .set('per_page', per_page);

    return this.http.get<any>(
      API_ROUTES.ARCHIVE.UNCATEGORIZED_FILES,
      { params: params, observe: 'response' }
    ).pipe(
      map(response => {
        const totalCount = response.headers?.get('x-total-count') ? Number(response.headers.get('x-total-count')) : 0;
        return { data: response.body.data || [], totalCount: totalCount };
      }));
  }

  retryFileProcessing(fileId: string): Observable<any> {
    const payload = {
    };

    return this.http.post<any>(
      `${API_ROUTES.ARCHIVE.RETRY}/${fileId}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS, responseType: 'text' as 'json' },
    );
  }
}
